<template>
  <section class="industry-experience-section">
    <div class="container">
      <!-- 顶部经验描述区 -->
      <div class="top-experience-area">
        <div class="text-content">
          <h2 class="main-title">{{ $t('industryExperience.mainTitle') }}</h2>
          <p class="sub-title">{{ $t('industryExperience.subTitle') }}</p>
          <p class="description">{{ $t('industryExperience.description') }}</p>
        </div>
        <div class="image-wrapper">
          <img :src="topImage" :alt="$t('industryExperience.imageAlt')" class="experience-image">
        </div>
      </div>

      <!-- 底部三个特性区 -->
      <div class="features-area">
        <div class="feature-item" v-for="feature in features" :key="feature.iconKey">
          <div class="feature-icon-wrapper">
            <img :src="getIconPath(feature.iconKey)" :alt="feature.title" class="feature-icon">
          </div>
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-text">{{ feature.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'IndustryExperience',
  data() {
    return {
      // 确保这个图片在 src/assets/images/ 目录下
      topImage: require('@/assets/gzll.jpg') // 替换为你的图片路径
    };
  },
  computed: {
    features() {
      // 从 i18n 获取特性列表，这样文本就是响应式的
      const i18nFeatures = this.$t('industryExperience.features');
      if (Array.isArray(i18nFeatures)) {
        return i18nFeatures.map(featureData => ({
          iconKey: featureData.iconKey, // 'team', 'resources', 'service'
          title: featureData.title,     // 从 i18n 获取的标题
          text: featureData.text        // 从 i18n 获取的文本
        }));
      }
      return []; // 如果 i18n 数据不是数组，返回空数组
    }
  },
  methods: {
    getIconPath(iconKey) {
      try {
        return require(`@/assets/${iconKey}.webp`); // 或者 .png
      } catch (e) {
        console.warn(`图标未找到: src/assets/icons/${iconKey}.svg`);
        return 'https://via.placeholder.com/80?text=Icon'; 
      }
    }
  }
};
</script>

<style scoped>
.industry-experience-section {
  padding: 60px 0;
  background-color: #fff; /* 或者你希望的背景色 */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 顶部经验描述区 */
.top-experience-area {
  display: flex;
  align-items: center; /* 垂直居中文本和图片（如果高度不一致） */
  gap: 40px; /* 文本和图片之间的间距 */
  margin-bottom: 70px; /* 与下方特性区的间距 */
}

.top-experience-area .text-content {
  flex: 1; /* 占据可用空间 */
  max-width: 50%; /* 限制文本区域宽度，给图片留空间 */
}

.top-experience-area .main-title {
  font-size: 2.5em; /* 根据图片调整 */
  color: #2c3e50;
  margin-bottom: 5px;
  font-weight: 600;
}

.top-experience-area .sub-title {
  font-size: 1.1em;
  color: #7f8c8d; /* 副标题颜色稍浅 */
  margin-bottom: 20px;
  font-weight: normal;
}

.top-experience-area .description {
  font-size: 1em;
  line-height: 1.7;
  color: #34495e;
}

.top-experience-area .image-wrapper {
  flex: 1;
  max-width: 50%;
}

.top-experience-area .experience-image {
  width: 100%;
  height: auto;
  border-radius: 8px; /* 轻微圆角 */
  object-fit: cover;
}

/* 底部三个特性区 */
.features-area {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); /* 响应式三列布局 */
  gap: 40px; /* 特性之间的间距 */
  text-align: center; /* 图标和文本居中 */
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feature-icon-wrapper {
  width: 90px; /* 图标容器大小 */
  height: 90px;
  border-radius: 50%;
  background-color: #fff; /* 图标背景色 */
  border: 2px solid #007bff; /* 蓝色圆形边框 */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 4px 10px rgba(0, 123, 255, 0.15);
}

.feature-icon {
  width: 40px; /* 图标实际大小 */
  height: 40px;
  object-fit: contain;
}

.feature-title {
  font-size: 1.4em;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: 600;
}

.feature-text {
  font-size: 0.95em;
  line-height: 1.6;
  color: #555;
  max-width: 300px; /* 限制文本宽度，使其更易读 */
  margin: 0 auto; /* 使其在父容器中居中 */
}

/* 响应式调整 */
@media (max-width: 992px) {
  .top-experience-area {
    flex-direction: column; /* 在较小屏幕上堆叠 */
    text-align: center;
  }
  .top-experience-area .text-content,
  .top-experience-area .image-wrapper {
    max-width: 100%;
  }
  .top-experience-area .image-wrapper {
    margin-top: 30px;
  }
}

@media (max-width: 768px) {
  .top-experience-area .main-title {
    font-size: 2em;
  }
  .features-area {
    grid-template-columns: 1fr; /* 单列显示 */
    gap: 50px; /* 单列时间距可以大一些 */
  }
  .feature-title {
    font-size: 1.3em;
  }
}
</style>